const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import ReactPlayer from 'react-player/lazy';
import { encode } from 'html-entities';

//Import Designs
import {
    Typography,
    Grid2,
    Dialog,
    DialogTitle as MuiDialogTitle,
    DialogContent as MuiDialogContent,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

class Showallpopup extends Component {
    constructor(props) {
        super(props);
        this.state = { anchorEl: '', open: '' };
    }

    render() {
        let post = this.props.post;
        const { votes_cont_title_font_size, votes_cont_title_color_hover_grid } = this.props.settings.color;
        let video_height = '300';
        let music_height = '300';
        if (post) {
            let image_size = post.popup_image != null ? post.popup_image : post.featured_image_url;
            let contest_type = post.img_contest;
            let url_video = null
            if (contest_type != null && contest_type == 'video') {
                url_video = this.props.singlepost.custom_fields_value["contestant-ow_video_url"];
            } else if (contest_type != null && contest_type == 'music') {
                url_video = this.props.singlepost.custom_fields_value["contestant-ow_music_url_link"];
                if (url_video == null) {
                    url_video = this.props.singlepost.custom_fields_value["contestant-ow_music_url"];
                }
            }

            return (
                (<Dialog onClose={this.props.handlemodal} className="wpvc_contestant_popup_container" aria-labelledby="customized-dialog-title" open={this.props.open_val}>
                    <MuiDialogTitle component="div" className="wpvc_contestant_popup_title" onClose={this.props.handlemodal}>
                        <Typography variant="h5" className="wpvc_grid_header" style={{ fontSize: votes_cont_title_font_size + 'px', 'color': votes_cont_title_color_hover_grid }}
                        >
                            {post.post_title}
                        </Typography>

                        <IconButton aria-label="close" onClick={this.props.handlemodal}>
                            <CloseIcon />
                        </IconButton>
                    </MuiDialogTitle>
                    <MuiDialogContent dividers className="wpvc_contestant_popup_content wpvc_show_allcontestant_popup_content" >
                        <Grid2 container className="wpvc_showcontestant_popup_container">

                            <Grid2 className="wpvc_popup_item_btns" size={12}>
                                {(post.img_contest == "photo" || post.img_contest == "essay") &&
                                    <img className={"wpvc_contestant_popup_image"} src={image_size} title={post.post_title} />
                                }
                                {(post.img_contest == "video" || post.img_contest == "music") &&
                                    <ReactPlayer url={encode(url_video)}
                                        playing={false} width="100%"
                                        height={(contest_type == 'video') ? video_height + 'px' : music_height + 'px'}
                                        controls={true}
                                        className={(contest_type == 'music') ? "wpvc_music_contest_player" : "wpvc_video_contest_player"}
                                    />
                                }
                            </Grid2>

                        </Grid2>
                    </MuiDialogContent>
                </Dialog>)
            );
        }

    }
}

export default connect()(withTranslation("translations")(Showallpopup));
